/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KinnserPatientMatch
 */
export interface KinnserPatientMatch {
    /**
     * 
     */
    patient_key: string;
    /**
     * 
     */
    in_clinic: boolean;
    /**
     * 
     */
    medical_record_number: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    middle_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    suffix: string;
    /**
     * 
     */
    date_of_birth: string;
    /**
     * 
     */
    sex: string;
    /**
     * 
     */
    confidence_score: number;
    /**
     * 
     */
    matching_fields: Array<string>;
}

/**
 * Check if a given object implements the KinnserPatientMatch interface.
 */
export function instanceOfKinnserPatientMatch(value: object): value is KinnserPatientMatch {
    if (!('patient_key' in value) || value['patient_key'] === undefined) return false;
    if (!('in_clinic' in value) || value['in_clinic'] === undefined) return false;
    if (!('medical_record_number' in value) || value['medical_record_number'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('middle_name' in value) || value['middle_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('suffix' in value) || value['suffix'] === undefined) return false;
    if (!('date_of_birth' in value) || value['date_of_birth'] === undefined) return false;
    if (!('sex' in value) || value['sex'] === undefined) return false;
    if (!('confidence_score' in value) || value['confidence_score'] === undefined) return false;
    if (!('matching_fields' in value) || value['matching_fields'] === undefined) return false;
    return true;
}

export function KinnserPatientMatchFromJSON(json: any): KinnserPatientMatch {
    return KinnserPatientMatchFromJSONTyped(json, false);
}

export function KinnserPatientMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_key': json['patient_key'],
        'in_clinic': json['in_clinic'],
        'medical_record_number': json['medical_record_number'],
        'first_name': json['first_name'],
        'middle_name': json['middle_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'],
        'date_of_birth': json['date_of_birth'],
        'sex': json['sex'],
        'confidence_score': json['confidence_score'],
        'matching_fields': json['matching_fields'],
    };
}

export function KinnserPatientMatchToJSON(json: any): KinnserPatientMatch {
    return KinnserPatientMatchToJSONTyped(json, false);
}

export function KinnserPatientMatchToJSONTyped(value?: KinnserPatientMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_key': value['patient_key'],
        'in_clinic': value['in_clinic'],
        'medical_record_number': value['medical_record_number'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'date_of_birth': value['date_of_birth'],
        'sex': value['sex'],
        'confidence_score': value['confidence_score'],
        'matching_fields': value['matching_fields'],
    };
}

